export default "__VITE_ASSET__DLpc_Quz__"